import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: 'hover:bg-primary-50 border-primary-100',
    text: 'text-primary-700',
    iconBg: 'bg-primary-100',
  },
  accent: {
    bg: 'hover:bg-accent-50 border-accent-100',
    text: 'text-accent-700',
    iconBg: 'bg-accent-100',
  },
  secondary: {
    bg: 'hover:bg-secondary-50 border-secondary-100',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-100',
  },
};

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            全部分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            涵盖电影、电视剧、综艺、动漫等多种类型，总有你想看的
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl border transition-all cursor-pointer ${colors.bg}`}
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl ${colors.iconBg} ${colors.text} group-hover:scale-110 transition-transform`}>
                  <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
                </div>
                <span className="font-medium text-sm md:text-base text-foreground-800">{cat.name}</span>
                <span className="text-xs text-foreground-400">{cat.count.toLocaleString()}部</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}